// src/pages/BlogsPage.js
import React from 'react';
import BlogUploader from '../../components/BlogUploader'; // Now text-only
import BlogFeed from '../../components/BlogFeed';       
// Assuming firebase.js is properly configured elsewhere, removed unneeded direct import.

// --- Dummy Authentication Logic for Illustration ---
const useAuthContext = () => {
    // This local logic is used to determine the user's role on this page.
    const user = { 
        uid: 'DIETITIAN_12345', 
        name: 'Nutrition Trends', 
        role: 'dietitian' 
    }; 
    return { 
        user, 
        isDietitian: user && user.role === 'dietitian' 
    };
};
// ----------------------------------------------------


const BlogsPage = () => {
    const { user, isDietitian } = useAuthContext(); 

    return (
        <div className="blogs-page-container">
            <h1 className="blogs-page-header">
                {isDietitian ? "Dietitian Blog Management" : "Customer Resource Center"} 
                {isDietitian ? ' 📝' : ' 📚'}
            </h1>

            {isDietitian && user && (
                <div className="uploader-section">
                    <h2 className="section-title">Write New Post</h2>
                    <BlogUploader 
                        dietitianUid={user.uid} 
                        dietitianName={user.name} 
                    />
                    <hr className="section-divider" />
                    <h2 className="section-title">Published Blogs & Drafts</h2>
                    {/* The BlogFeed component should be re-used here to display drafts */}
                    {/* For example, by passing a specific query filter to BlogFeed */}
                </div>
            )}
            
            <div className="feed-section">
                <BlogFeed 
                    isDietitianView={isDietitian} 
                />
            </div>

        </div>
    );
};

export default BlogsPage;